<template>
	<div :style="homeStyle">

		<b-modal ref="emptyId"
			hide-footer
			static="true"
			:lazy=true
			:title="$t('Errors.error')">
			<p class="my-4">{{ this.inputsError }}</p>
		</b-modal>

		<b-modal ref="licenseRenew"
			hide-footer
			static="true"
			:lazy=true
			:title="$t('Login.licenseRenewTitle')">
			<p class="my-4">{{ $t('Login.licenseRenew') }}</p>
		</b-modal>

		<b-modal ref="licenseObsolete"
			hide-footer
			static="true"
			:lazy=true
			:title="$t('Login.licenseObsoleteTitle')">
			<p class="my-4">{{ this.inputsError }}</p>
			<b-row>
				<b-col>
					<b-button class="w-100" @click.prevent="order_license">{{ $t('Login.orderLicense') }}</b-button>
				</b-col>
				<b-col>
					<b-button class="w-100" href="https://horoquartz.enjoyb.net/buy/license">{{
							$t('Login.buyLicense')
						}}
					</b-button>
				</b-col>
			</b-row>
		</b-modal>

		<b-img src="./static/images/logohome.png"
			alt="Logo"
			class="entete-logo">
		</b-img>

		<div class="title" v-if="false">
			<b-img src="./static/images/entetehome.png" alt="Enjoyb" />
		</div>
		<div class="description" v-if="false">
			<p>Synchronisée avec votre application mobile Enjoyb, la plateforme vous permet de modifier vos projets vidéos et d’en créer de nouveau :
			</p>
			<p class="translation">Synchronized with your mobile application Film & Go, the platform allows you to edit your video projects and create new ones:
			</p>
		</div>

		<div class="form-grid">
			<form class="cell form-login">
				<p>Connexion / Log in</p>
				<b-form-input class="input-form-id"
					type="text"
					placeholder="Email"
					v-model="input.email"
					autocomplete="on">
				</b-form-input>
				<b-form-input class="input-form-email"
					type="password"
					:placeholder="$t('Login.password')"
					v-model="input.password"
					autocomplete="off">
				</b-form-input>
				<b-button class="my-2 my-sm-0 btn-login"
					@click.prevent="connexion">{{ $t('Login.login') }}
				</b-button>
			</form>

			<div class="links-box cell" v-if="false">
				<!--				<b-button class="button" href="https://horoquartz.enjoyb.net/buy/license">Acheter une licence</b-button>-->
				<!--				<p class="translation">Buy a license</p>-->
				<b-button class="button" href="mailto:appli@enjoyb.fr?subject=Demande%20d'acc%C3%A8s%20%C3%A0%20HQ%20Vid%E9o&body=Bonjour%2C%20je%20souhaiterais%20b%C3%A9n%C3%A9fichier%20d'un%20acc%C3%A8s%20%C3%A0%20l'application%20HQ%20Vid%E9o.">Demander un accès</b-button>
				<p class="translation">Ask for an access</p>
				<!--				<b-button class="button" href="https://api.enjoyb.fr/scep/enjoyb/register">Associer votre téléphone (iOS uniquement)</b-button>-->
				<!--				<p class="translation">Add your phone (iOS only)</p>-->

				<b-button class="button" href="https://play.google.com/store/apps/details?id= ">Télécharger l'application Android.</b-button>
				<p class="translation">Download the Android app.</p>
				<b-button class="button" href="https://apps.apple.com/fr/app/ ">Télécharger l'application iOS.</b-button>
				<p class="translation">Download the iOS app.</p>
			</div>
		</div>

		<div class="grid-bulletpoints" v-if="false">
			<div class="cell">
				<div class="bullet">
					<b-img src="./static/images/home1.png" />
				</div>
				<div class="text">
					<p>Même identifiant de connexion que votre application</p>
					<p class="translation">Same login ID as your app</p>
				</div>
			</div>
			<div class="cell">
				<div class="bullet">
					<b-img src="./static/images/home2.png" />
				</div>
				<div class="text">
					<p>Découpe de vos vidéos, insertion de nouvelles vidéos, insertion de plan de coupe, insertion de voix off, etc.
					</p>
					<p class="translation">Trimming your videos, importing new videos, inserting cut plane, inserting voiceovers, etc.
					</p>
				</div>
			</div>
			<div class="cell">
				<div class="bullet">
					<b-img src="./static/images/home3.png" />
				</div>
				<div class="text">
					<p>Correction des textes et sous-titrages</p>
					<p class="translation">Spell checking of texts and subtitles</p>
				</div>
			</div>
			<div class="cell">
				<div class="bullet">
					<b-img src="./static/images/home4.png" />
				</div>
				<div class="text">
					<p>Fonction de drag&drop</p>
					<p class="translation">Drag & drop feature</p>
				</div>
			</div>
			<div class="cell">
				<div class="bullet">
					<b-img src="./static/images/home5.png" />
				</div>
				<div class="text">
					<p>Gestion du droit à l’image</p>
					<p class="translation">Editing image rights</p>
				</div>
			</div>
			<div class="cell">
				<div class="bullet">
					<b-img src="./static/images/home6.png" />
				</div>
				<div class="text">
					<p>Indisponible sur les anciens navigateurs (Explorer)</p>
					<p class="translation">Not available on older browsers (Explorer)</p>
				</div>
			</div>

		</div>

	</div>
</template>

<script>
import Login from "@/components/ui/Login";
import axios from "axios";
import {EventBus} from "../../event/event-bus";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	name: "Home",
	components: {Login},
	data() {
		return {
			styles: {
				background: "url('" + process.env.VUE_APP_SPLASHSCREEN_PATH + "') no-repeat center center fixed " +
					process.env.VUE_APP_PRIMARY_COLOR,
				backgroundSize: "contain",
				backgroundColor: "white",
				height: "100vh",
			},
			homeStyle: {
				height: "100vh",
				width: "100%",
				background: "url('" + process.env.VUE_APP_HOME_BACKGROUND + "') no-repeat center center fixed ",
				backgroundSize: "cover",
				overflowY: "scroll",
			},
			input: {
				email: "",
				password: "",
			},
			inputsError: "",
		};
	},
	created() {
		let $this = this;
		EventBus.$on("setLanguage", lang => {
			$this.$root.$i18n.locale = lang;
		});
	},
	methods: {
		connexion() {
			if (this.input.email !== "" && this.input.password !== "") {
				let $this = this;
				let bodyFormData = new FormData();
				if ($this.input.email.length > 0) {
					bodyFormData.append("email", $this.input.email);
				}
				if ($this.input.password.length > 0) {
					bodyFormData.append("password", $this.input.password);
				}
				axios.post(BASE_URL + "/public/api/login",
					bodyFormData,
					{
						headers: {
							"Content-Type": "multipart/form-data",
						},
					},
				).catch(function (error) {
					console.log(error);
					if (error.response.status === 401) {
						$this.inputsError = $this.$root.$t("Login.userNotFound");
						$this.$refs.emptyId.show();
					}
					else if (error.response.status === 402) {
						$this.inputsError = $this.$root.$t("Login.licenseObsolete");
						$this.$refs.licenseObsolete.show();
					}
				}).then(response => {
					let data = response.data;
					if (response.status === 200) {
						sessionStorage.setItem("isConnected", true);
						sessionStorage.setItem("username", data.user.name);
						sessionStorage.setItem("usermail", data.user.email_address);
						sessionStorage.setItem("auth", data.auth);

						$this.$router.push({name: "Dashboard"});
					}
					else {
						this.inputsError = $this.$root.$t("Login.notAllowed");
						this.$refs.emptyId.show();
					}
				});
			}
			else {
				this.inputsError = this.$root.$t("Login.empty");
				this.$refs.emptyId.show();
			}
		},
		order_license() {
			this.$refs.licenseObsolete.hide();
			let $this = this;
			let bodyFormData = new FormData();
			if ($this.input.email.length > 0) {
				bodyFormData.append("email", $this.input.email);
			}
			axios.post("https://horoquartz.enjoyb.net/py/form/renew",
				bodyFormData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				},
			).catch(function (error) {
				console.log(error);
			}).then(response => {
				$this.$refs.licenseRenew.show();
			});
		},
	},
};
</script>

<style scoped>

p {
	font-size: 16px;
	margin: 0;
	font-weight: bold;
	color: var(--text-main);
}

p.translation {
	font-weight: normal;
	color: #6C757D;
}

.entete-logo {
	display: block;
	max-width: 500px;
	margin: 0 auto 0;
}

.title {
	width: 434px;
	margin: -38px auto 0;
}

.title img {
	display: block;
	width: 401px;
	margin-left: 33px;
}

.description {
	max-width: 800px;
	margin: 0 auto;
	padding: 10px;
	text-align: center;
}

.grid-bulletpoints {
	margin: 35px 0;
	display: grid;
	grid-template-columns: 615px;
	grid-template-rows: repeat(3, minmax(54px, auto));
	column-gap: 90px;
	row-gap: 33px;
	justify-content: center;
	grid-auto-flow: column;
}

@media (max-width: 1500px) {
	.grid-bulletpoints {
		grid-template-columns: 615px;
		grid-template-rows: repeat(6, minmax(54px, auto));
	}
}

.grid-bulletpoints .cell {
	display: flex;
	align-items: center;
}

.bullet {
	background: #FFFFFF;
	margin-right: 28px;
	border-radius: 27px;
}

.bullet img {
	display: block;
	margin: 12px;
}

.form-grid {
	display: grid;
	/*grid-template-columns: repeat(1, 340px);*/
	gap: 36px;
	margin: 38px auto;
	justify-content: center;

}

.entete-logo {
	margin-top:150px;
}

.entete-logo + .form-grid {
	margin-top:100px;
}

@media (max-width: 800px) {
	.form-grid {
		grid-template-columns: 340px;
		gap: 36px;
		margin: 38px auto;
		justify-content: center;
	}
}

.links-box {
	text-align: center;
}

.links-box p:not(:last-of-type) {
	margin-bottom: 20px;
}

.links-box p {
	font-size: .75em;
}

.form-grid .cell {
	border-radius: var(--big-border-radius);
	background: #F7F7F7;
	padding: 33px;
	box-shadow: 3px 3px 8px #00000080;
}

.form-login p {
	margin-bottom: 5px;
}

.form-login input {
	margin-bottom: 16px;
}

.form-grid button,
.form-grid .button {
	background: var(--color-validation);
	color: var(--text-validation);
	width: 274px;
	border-radius: var(--small-border-radius);
}

</style>
